module.exports = ".col-xs-11, .col-xs-1, .row {\n\tpadding: 0px;\n}\n.col-xs-1 {\n\ttext-align: left;\n}\n.i.fa.fa-question-circle {\n\tvertical-align: sub;\n\tmargin-left: 0px;\n}\nh4 {\n\tmargin-top: 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sites/site-form.component.css
// module id = 1667
// module chunks = 0